const withWebsocket = require('./websocketHOC');
const WebsocketComponent = require('./websocketComponent');
const useWebsocket = require('./useWebsocket');

module.exports = ({
  useWebsocket,
  WebsocketComponent,
  withWebsocket,
});
